export const RE_BACKGROUND = 'dimgray';
export const OPTIONS_KEY = 'RE OPTIONS';
export const HELPED_KEY = 'RE HELPED';
export const RE_RED = 'darkred';
export const RE_GREEN = 'darkgreen';
export const RE_NAVY = 'navy';
export const RE_PURPLE = 'purple';
export const RE_YELLOW = 'rgb(178,98,0)';
export const RE_BLUE = 'rgb(63,117,162)';
export const MOVE_DURATION = 1000;
export const MAX_SECS = [30, 90, 150, 210, 300];
export const YOUTUBE_RE = 'https://youtu.be/djfDd5yMZWo';
